import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { CommentSubjectType } from "@/domain/comment";

export interface CommentsPageScope {
  page: string;
  subjectType?: CommentSubjectType;
  record?: { uuid: string; name: string };
  visible: string[];
}
interface CommentsScopeState {
  scope: CommentsPageScope | null;
  open: boolean;
  thread: string | null;
  mode: "all" | "page";
  status: "open" | "resolved";
  setScope: (scope: CommentsPageScope | null) => void;
  setOpen: (open: boolean) => void;
  setThread: (thread: string | null) => void;
  setMode: (mode: "all" | "page") => void;
  setStatus: (status: "open" | "resolved") => void;
  reset: () => void;
}
const initial = { scope: null, open: false, thread: null, mode: "all", status: "open" } as const;
export const useCommentsScopeStore = create<CommentsScopeState>()(
  devtools(
    (set) => ({
      ...initial,
      setScope: (scope) =>
        set((state) => ({
          scope,
          thread:
            state.scope?.record?.uuid === scope?.record?.uuid && state.scope?.page === scope?.page
              ? state.thread
              : null,
        })),
      setOpen: (open) => set({ open }),
      setThread: (thread) => set({ thread, open: true }),
      setMode: (mode) => set({ mode, thread: null }),
      setStatus: (status) => set({ status, thread: null }),
      reset: () => set(initial),
    }),
    { name: "CommentsScopeStore" },
  ),
);
